module.exports = __webpack_public_path__ + "img/BR.8642c565.png";